import * as React from 'react';
export const schoolsfirstSvg = React.forwardRef(function schoolsfirstSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#5B7896',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.137 24.085c-2.859-2.983-6.216-1.813-9.785-2.225V7.5c3.578.412 6.916-.623 9.785 2.206v14.38Z',
      fill: '#D5DCE4',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.353 7.5v14.36L5 22.656V9.092L6.353 7.5Zm19.558 0c-3.568.412-6.916-.623-9.784 2.206v14.38c2.859-2.984 6.206-1.814 9.784-2.226V7.5Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.137 24.085c-2.859-2.983-6.216-1.813-9.784-2.225L5 22.656l8.671 1.938s.068.01 0 .038c-.143.048-1.131.403-1.458.537 0 0-.01 0-.01.02 0 0 0 .018.02.018L29 24.92V11.155h-1.832V8.67L25.92 7.5v14.36c-3.54.412-6.935-.748-9.775 2.225',
      fill: '#394B57',
    }),
  );
});
schoolsfirstSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var schoolsfirst = {
  category: 'brand',
  colorable: false,
  name: 'schoolsfirst',
  svg: schoolsfirstSvg,
};
